import React, { createContext, useContext } from 'react';
import RootStore from './store/RootStore';

// new RootStore will be replaced, but initialised for typescript
export const AppContext = createContext<RootStore>(new RootStore());

interface IProvider {
  store: RootStore;
  children: React.ReactNode;
}

export const StoreProvider = ({ store, children }: IProvider) => (
  <AppContext.Provider value={store}>{children}</AppContext.Provider>
);

export const useStore = () => useContext(AppContext);
